import React from 'react';
import TestCaseList from '../shared/TestCaseList';

export function DFATestCases({ onLoadTest, currentExample }) {

  const getTestCases = () => {
    if (currentExample === 'lexer_digits_plus') {
      return [
        { input: '42', expected: 'Accept', shouldAccept: true },
        { input: '0', expected: 'Accept', shouldAccept: true },
        { input: '9876543210', expected: 'Accept', shouldAccept: true },
        { input: '', expected: 'Reject', shouldAccept: false },
        { input: '42a', expected: 'Reject', shouldAccept: false },
      ];
    }
    if (currentExample === 'lexer_digit_once') {
      return [
        { input: '7', expected: 'Accept', shouldAccept: true },
        { input: '42', expected: 'Reject', shouldAccept: false },
        { input: '', expected: 'Reject', shouldAccept: false },
      ];
    }
    if (currentExample === "ends_with_ab") {
      return [
        { input: 'ab', expected: 'Accept', shouldAccept: true },
        { input: 'aab', expected: 'Accept', shouldAccept: true },
        { input: 'bab', expected: 'Accept', shouldAccept: true },
        { input: 'aaab', expected: 'Accept', shouldAccept: true },
        { input: 'a', expected: 'Reject', shouldAccept: false },
        { input: 'b', expected: 'Reject', shouldAccept: false },
        { input: 'ba', expected: 'Reject', shouldAccept: false },
        { input: 'aba', expected: 'Reject', shouldAccept: false },
      ];
    } else if (currentExample === "contains_aa") {
      return [
        { input: 'aa', expected: 'Accept', shouldAccept: true },
        { input: 'aab', expected: 'Accept', shouldAccept: true },
        { input: 'baa', expected: 'Accept', shouldAccept: true },
        { input: 'baab', expected: 'Accept', shouldAccept: true },
        { input: 'a', expected: 'Reject', shouldAccept: false },
        { input: 'b', expected: 'Reject', shouldAccept: false },
        { input: 'ab', expected: 'Reject', shouldAccept: false },
        { input: 'aba', expected: 'Reject', shouldAccept: false },
      ];
    } else if (currentExample === "even_number_of_as") {
      return [
        { input: '', expected: 'Accept', shouldAccept: true },
        { input: 'aa', expected: 'Accept', shouldAccept: true },
        { input: 'b', expected: 'Accept', shouldAccept: true },
        { input: 'bbaabb', expected: 'Accept', shouldAccept: true },
        { input: 'a', expected: 'Reject', shouldAccept: false },
        { input: 'aaa', expected: 'Reject', shouldAccept: false },
        { input: 'ba', expected: 'Reject', shouldAccept: false },
        { input: 'aaab', expected: 'Reject', shouldAccept: false },
      ];
    } else if (currentExample === "divisible_by_3") {
      return [
        { input: '0', expected: 'Accept (0 ÷ 3)', shouldAccept: true },
        { input: '11', expected: 'Accept (3 ÷ 3)', shouldAccept: true },
        { input: '110', expected: 'Accept (6 ÷ 3)', shouldAccept: true },
        { input: '1001', expected: 'Accept (9 ÷ 3)', shouldAccept: true },
        { input: '1', expected: 'Reject (1)', shouldAccept: false },
        { input: '10', expected: 'Reject (2)', shouldAccept: false },
        { input: '100', expected: 'Reject (4)', shouldAccept: false },
        { input: '101', expected: 'Reject (5)', shouldAccept: false },
      ];
    } else if (currentExample === "starts_with_ab") {
      return [
        { input: 'ab', expected: 'Accept', shouldAccept: true },
        { input: 'aba', expected: 'Accept', shouldAccept: true },
        { input: 'abb', expected: 'Accept', shouldAccept: true },
        { input: 'abab', expected: 'Accept', shouldAccept: true },
        { input: 'a', expected: 'Reject', shouldAccept: false },
        { input: 'b', expected: 'Reject', shouldAccept: false },
        { input: 'ba', expected: 'Reject', shouldAccept: false },
        { input: 'aa', expected: 'Reject', shouldAccept: false },
      ];
    } else if (currentExample === "contains_aba") {
      return [
        { input: 'aba', expected: 'Accept', shouldAccept: true },
        { input: 'abab', expected: 'Accept', shouldAccept: true },
        { input: 'babab', expected: 'Accept', shouldAccept: true },
        { input: 'aaba', expected: 'Accept', shouldAccept: true },
        { input: 'ab', expected: 'Reject', shouldAccept: false },
        { input: 'ba', expected: 'Reject', shouldAccept: false },
        { input: 'aa', expected: 'Reject', shouldAccept: false },
        { input: 'bb', expected: 'Reject', shouldAccept: false },
      ];
    } else if (currentExample === "at_least_two_as") {
      return [
        { input: 'aa', expected: 'Accept', shouldAccept: true },
        { input: 'aaa', expected: 'Accept', shouldAccept: true },
        { input: 'aab', expected: 'Accept', shouldAccept: true },
        { input: 'baab', expected: 'Accept', shouldAccept: true },
        { input: 'a', expected: 'Reject', shouldAccept: false },
        { input: 'b', expected: 'Reject', shouldAccept: false },
        { input: 'ab', expected: 'Reject', shouldAccept: false },
        { input: 'ba', expected: 'Reject', shouldAccept: false },
      ];
    } else if (currentExample === "even_parity") {
      return [
        { input: '', expected: 'Accept', shouldAccept: true },
        { input: '00', expected: 'Accept', shouldAccept: true },
        { input: '11', expected: 'Accept', shouldAccept: true },
        { input: '1010', expected: 'Accept', shouldAccept: true },
        { input: '1', expected: 'Reject', shouldAccept: false },
        { input: '10', expected: 'Reject', shouldAccept: false },
        { input: '101', expected: 'Reject', shouldAccept: false },
        { input: '111', expected: 'Reject', shouldAccept: false },
      ];
    } else if (currentExample === "no_consecutive_as") {
      return [
        { input: '', expected: 'Accept', shouldAccept: true },
        { input: 'a', expected: 'Accept', shouldAccept: true },
        { input: 'b', expected: 'Accept', shouldAccept: true },
        { input: 'abab', expected: 'Accept', shouldAccept: true },
        { input: 'aa', expected: 'Reject', shouldAccept: false },
        { input: 'baa', expected: 'Reject', shouldAccept: false },
        { input: 'aab', expected: 'Reject', shouldAccept: false },
        { input: 'baab', expected: 'Reject', shouldAccept: false },
      ];
    } else if (currentExample === "exactly_two_as") {
      return [
        { input: 'aa', expected: 'Accept', shouldAccept: true },
        { input: 'aab', expected: 'Accept', shouldAccept: true },
        { input: 'baab', expected: 'Accept', shouldAccept: true },
        { input: 'abab', expected: 'Accept', shouldAccept: true },
        { input: 'a', expected: 'Reject', shouldAccept: false },
        { input: 'aaa', expected: 'Reject', shouldAccept: false },
        { input: 'b', expected: 'Reject', shouldAccept: false },
        { input: 'ab', expected: 'Reject', shouldAccept: false },
      ];
    }
    return [];
  };

  const testCases = getTestCases();

  if (testCases.length === 0) {
    return null;
  }

    return <TestCaseList testCases={testCases} onLoadTest={onLoadTest} />;
}
